module.exports = __webpack_public_path__ + "img/four_hands_color_logo.2d3835b.png";